import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Main } from "./pages/Main";
import { Privacy } from "./pages/Privacy";
import "./index.css"

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
  },
  {
    path: "privacy",
    element: <Privacy />,
  },
]);

createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);